export default {
  window: {
    width: 1,
    height: 1
  },
  colors: {
    a: {
      bg: '#011e2b', // '#ff36a2',
      fg: '#ffffff'
    },
    b: {
      bg: '#ff36a2', // '#ffe803',
      fg: '#030303'
    }
  }
}
